import theme from './default';
import dark from './dark';

const themes = {
  default: theme,
  dark,
};

export default themes;
